import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
} from "@angular/router";

/**
 * Search guard : redirect to 404 if the query param s is empty
 */
@Injectable()
export class SearchGuard implements CanActivate {
    constructor(private router: Router) {}
    /**
     * @returns true if a category corresponding to the url in the route exists
     */
    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): boolean {
        const searchTerm = route.queryParams.s;
        if (!searchTerm) {
            this.router.navigate(["/404-error"], {
                // minimal effect. see https://github.com/angular/angular/issues/17004
                skipLocationChange: true,
                queryParams: {
                    originalUrl: state.url,
                    statusCode: 400,
                },
            });
            return false;
        }
        return true;
    }
}
